import { useState } from "react";
import { createContact } from "../services/api"; // Đảm bảo đường dẫn đúng

const initialState = {
  name: "",
  phone: "",
  address: "",
  email: "",
  message: "",
};

export default function ContactForm() {
  const [formData, setFormData] = useState(initialState);
  const [touched, setTouched] = useState({});
  const [status, setStatus] = useState(""); // '', 'sending', 'success', 'error'

  // Xác thực
  const validate = {
    name: formData.name.trim().length > 0,
    phone: /^(?:\+84|0)(3|5|7|8|9)[0-9]{8}$/.test(formData.phone),
    email: /^[\w.-]+@[\w.-]+\.\w+$/.test(formData.email),
    address: true, // không bắt buộc
    message: true, // không bắt buộc
  };

  const isFormValid = Object.values(validate).every(Boolean);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
  };

  const inputClass = (field) => {
    if (!touched[field]) return "border-gray-300";
    return validate[field] ? "border-green-500" : "border-red-500";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isFormValid) {
      setTouched({
        name: true,
        phone: true,
        email: true,
      });
      return;
    }

    try {
      setStatus("sending");
      await createContact(formData);
      setStatus("success");
      setFormData(initialState);
      setTouched({});
      setTimeout(() => setStatus(""), 4000);
    } catch (err) {
      console.error("Gửi thất bại:", err);
      const errorCode = err?.response?.data?.error_code;
      if (errorCode === "DUPLICATE_CONTACT") {
        setStatus("duplicate");
      } else {
        setStatus("error");
      }
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="w-full max-w-xl mx-auto bg-white shadow-2xl rounded-2xl p-6 space-y-4"
    >
      <h2 className="text-2xl font-bold text-center text-red-600">Để lại thông tin để được tư vấn miễn phí nhé!</h2>

      {/* Họ tên */}
      <div>
        <label className="block font-semibold mb-1">
          Họ và tên <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          onBlur={handleBlur}
          className={`w-full px-4 py-2 border rounded-md focus:outline-none ${inputClass("name")}`}
          placeholder="Nguyễn Văn A"
        />
      </div>

      {/* Số điện thoại */}
      <div>
        <label className="block font-semibold mb-1">
          Số điện thoại <span className="text-red-500">*</span>
        </label>
        <input
          type="tel"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          onBlur={handleBlur}
          className={`w-full px-4 py-2 border rounded-md focus:outline-none ${inputClass("phone")}`}
          placeholder="0901234567 or +84123456789"
        />
      </div>

      {/* Email */}
      <div>
        <label className="block font-semibold mb-1">
          Email <span className="text-red-500">*</span>
        </label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          onBlur={handleBlur}
          className={`w-full px-4 py-2 border rounded-md focus:outline-none ${inputClass("email")}`}
          placeholder="email@example.com"
        />
      </div>

      {/* Địa chỉ */}
      <div>
        <label className="block font-semibold mb-1">Địa chỉ</label>
        <input
          type="text"
          name="address"
          value={formData.address}
          onChange={handleChange}
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
          placeholder="123 Đường ABC, Quận XYZ"
        />
      </div>

      {/* Lời nhắn */}
      <div>
        <label className="block font-semibold mb-1">Lời nhắn</label>
        <textarea
          name="message"
          rows={4}
          value={formData.message}
          onChange={handleChange}
          className="w-full px-4 py-2 border border-gray-300 rounded-md resize-none focus:outline-none"
          placeholder="Bạn cần hỗ trợ gì?"
        ></textarea>
      </div>

      {/* Button */}
      <div className="pt-2">
        <button
          type="submit"
          disabled={!isFormValid}
          className={`w-full py-2 font-semibold rounded-md transition ${
            isFormValid
              ? "bg-red-600 text-white hover:bg-red-700"
              : "bg-gray-400 text-white cursor-not-allowed"
          }`}
        >
          Gửi liên hệ
        </button>
      </div>

      {/* Trạng thái */}
      {status === "success" && (
        <div className="text-green-600 text-center font-semibold mt-2">
          ✅ Cảm ơn bạn! Chúng tôi sẽ liên hệ với bạn sớm nhất có thể.
        </div>
      )}
      {status === "duplicate" && (
        <p className="text-green-600 text-center font-semibold mt-2">
          ✅ Bạn đã gửi thông tin trước đó. Chúng tôi sẽ liên lạc với bạn sớm nhất.
        </p>
      )}
      {status === "error" && (
        <p className="text-red-600 text-center font-semibold mt-2">
          ❌ Có lỗi xảy ra, vui lòng thử lại sau.
        </p>
      )}
    </form>
  );
}
